export default function toDate(dateStr) {
    if (!dateStr) {
        return null;
    }

    return new Date(dateStr);
}
